<template>
    <main>
        <form class="form-signin row" @submit="submit">
            <div class="col-md-4">
            </div>
            <div class="col-md-8">
                <b class="mb-3">ВОССТАНОВЛЕНИЕ ПАРОЛЯ</b>

                <div id="loginBlock" v-if="!multiple">
                    <input autocomplete="off" type="text" class="form-control mb-4" id="login" name="email" placeholder="Email" v-model="email">
                </div>

                <div v-if="multiple">
                    <p>Выберите логин для восстановления:</p>
                </div>

                <div v-if="multiple">
                    <div v-for="(login, index) in logins" v-bind:key="index">
                        <input type="button" class="btn btn-outline-primary btn-block" @click="restore(login.login)" :value="login.name + ' ' + login.login" />
                    </div><br/>
                </div>

                <button v-if="!multiple" class="btn btn-lg btn-primary btn-block mb-2" type="submit">Проверить</button>

                <a href="/login">Авторизация</a>
            </div>
        </form>
    </main>
</template>

<script>
    import makePost from '../js/makePost';

    export default {
        props: ['secret'],
        name: "ForgotPassword",
        metaInfo: {
            title: 'Восстановление пароля',
            titleTemplate: '%s - sale.katris'
        },
        data() {
            return {
                email: '',
                logins: [],
                multiple: false
            }
        },
        created() {
            if (this.secret) {
                makePost('katrisService', 'secret', {'secret': this.secret}, null, function(response) {
                    if (response.data.success) {
                        alert(response.data.success);
                        window.location.replace('/login');
                    } else {
                        if (response.data.error) {
                            alert(response.data.error)
                        } else {
                            alert('Ошибка восстановления пароля');
                        }
                        window.location.replace('/forgot');
                    }
                });
            }
        },
        methods: {
            submit: function(e) {
                let self = this;
                if (this.email != '' && !this.secret) {
                    makePost('katrisService', 'passwordRestore', {'email': this.email}, null, function(response) {
                        if (response.status === 'OK') {
                            if (!response.data.error && !response.data.logins) {
                                alert('Письмо для восстановления отправлено на почту. Срок доставки - до 20 минут.');
                            } else if (response.data.logins) {
                                self.multiple = true;
                                let logins = JSON.parse(response.data.logins);
                                for (let key in logins) {
                                    self.logins.push(logins[key]);
                                }
                            } else {
                                alert(response.data.error);
                            }
                        } else {
                            alert('Ошибка восстановления пароля');
                        }
                    });
                } else {
                    alert('Поля заполнены не верно');
                }
                e.preventDefault();
            },
            restore: function(login) {
                makePost('katrisService', 'restoreByLogin', {'login': login}, null, function(response) {
                    if (response.data == 'success') {
                        alert('Письмо для восстановления отправлено на почту. Срок доставки - до 20 минут.');
                    } else {
                        alert('Ошибка восстановления пароля');
                        window.location.replace('/forgot');
                    }
                });
            }
        }
    }
</script>

<style scoped>
    @import "./../assets/css/newLogin.css";

    .form-signin {
        width: 600px;
        min-height: 300px;
        padding: 15px;
        margin: auto;

        border-radius: 21px;

        -webkit-box-shadow: 0 0 10px 0 rgba(0,0,0,.8);
        box-shadow: 0 0 10px 0 rgba(0,0,0,.8);
        -webkit-box-shadow: 5px 5px 20px 0px rgba(0,0,0,.6);
        box-shadow: 5px 5px 20px 0px rgba(0,0,0,.6);

        background-image: url("./../assets/img/logo-katris.png");
        background-repeat: no-repeat;
        background-size: 30%;
    }



    /*@import "./../assets/css/login.css";*/
</style>
